// Behavior-level. No config schema, credential handling, or per-partner
// adapter internals.

export default {
  title: 'Fetch Engine',
  summary:
    'Pull data straight from your configured Partner APIs and inspect, filter, sort, and export the results — without leaving the dashboard.',

  sections: [
    {
      h: 'What this tool does',
      p: [
        'Runs against your saved Partner API configurations and fetches live data on demand.',
        'You choose the dimensions to group by and the metrics to pull, apply filters, then sort, search, and export the resulting table.',
      ],
    },
    {
      h: 'When to use it',
      list: [
        "A quick, ad-hoc pull from a partner's reporting API — without building a report or exporting from their own UI.",
        "Checking what a partner API actually returns for a given set of dimensions and metrics before wiring it into a monitor.",
      ],
    },
    {
      h: 'How to use it',
      steps: [
        '**Pick a Partner API config** (set one up first if you have none).',
        '**Choose dimensions and metrics**, and add any filters — each filter field shows a hint for what that partner expects.',
        '**Fetch**, then sort, search, and filter the table in place.',
        '**Export** once you\u2019ve got what you need.',
      ],
    },
    {
      callout:
        "The available dimensions, metrics, and filter formats are defined by each partner's API, not by the tool — so two configs can expose completely different options, and the hints reflect what that specific partner accepts.",
    },
  ],

  faqs: [
    {
      q: 'No configs to pick from?',
      a: 'You need at least one Partner API configuration before fetching — that\u2019s where the endpoint and credentials live.',
    },
    {
      q: 'A filter returned nothing?',
      a: 'Partner APIs are strict about value types and formats. Check the field hint — some fields expect exact values the partner recognizes, down to the type.',
    },
  ],
};
